<template>
  <div>
    <div id="el-card" class="tw-pt-4 tw-bg-white tw-shadow-md tw-pb-6 tw-px-4">
      <div class="tw-flex tw-justify-between tw-mb-8">
        <span class="tw-text-base tw-font-medium tw-leading-5 tw-text-black"
          >Injury Case - Summary</span
        >

        <span class="tw-text-base tw-leading-4 tw-text-green-700 tw-pt-0.5">
          <button
            type="link"
            class="tw-text-green-700 hover:tw-text-green-300 tw-underline tw-font-medium"
            @click="goToEditPage"
          >
            Edit Injury Report
          </button></span
        >
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Member injured</span>
        <span class="tw-text-right">{{ injury.member.name }}</span>
      </div>

      <div
        v-if="injury.meta.programId"
        class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px"
      >
        <span class="tw-text-gray-500">Program Name</span>
        <span class="tw-text-right">{{ programName }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Date of injury</span>
        <span class="tw-text-right">{{ formatDateOfInjury }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Time of injury</span>
        <span class="tw-text-right">{{ formatTimeOfInjury }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Injury occurence</span>
        <span class="tw-text-right">{{ injuryOccur }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Venue</span>
        <span class="tw-text-right">{{ injury.venue.formatted }}</span>
      </div>

      <div v-for="(bodyPart, index) in injury.natureOfInjury" :key="index">
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Body part</span>
          <span class="tw-text-right">{{ bodyPart.bodyArea }} {{ bodyPart.bodyPart }}</span>
        </div>

        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Injury</span>
          <span class="tw-text-right">{{
            bodyPart.injury === "Other" ? bodyPart.injuryOther : bodyPart.injury
          }}</span>
        </div>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Player injured by</span>
        <span class="tw-text-right">{{
          injury.howPlayerInjured === "Other"
            ? injury.howPlayerInjuredOther
            : injury.howPlayerInjured
        }}</span>
      </div>

      <div
        v-if="injury.symptons"
        class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px"
      >
        <span class="tw-text-gray-500">Concussion symptoms</span>
        <span class="tw-text-right">{{ formatBoolean(injury.symptons) }}</span>
      </div>

      <div v-if="injury.symptons && viewMore">
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Clinical features</span>
          <span class="tw-text-right">{{ formatBoolean(injury.concussion.clinicalFeatures) }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Loss of consciousness</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.lossOfConsciousness)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Protective action taken</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.protectiveAction)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Impact seizure/convulsion/fit</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.impact)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Balance disturbance/clumsy/slow</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.balanceDisturbance)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Dazed/blank/vacant stare</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.dazedOrBlank)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Unusual behaviour</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.unusualBehaviour)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Confusion or disorientation </span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.confusion)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Memory impairment</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.memoryImpairment)
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Other concussion symptoms</span>
          <span class="tw-text-right">{{
            this.convertBoolToString(injury.concussion.playerReports)
          }}</span>
        </div>

        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Displays usual self state</span>
          <span class="tw-text-right">{{ injury.symptomRecord.playerSelfState }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Headache</span>
          <span class="tw-text-right">{{ injury.symptomRecord.headache.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Pressure in the head</span>
          <span class="tw-text-right">{{ injury.symptomRecord.pressureInHead.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Neck Pain</span>
          <span class="tw-text-right">{{ injury.symptomRecord.neckPain.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Nausea/vomit</span>
          <span class="tw-text-right">{{ injury.symptomRecord.nauseaOrVomit.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Dizziness</span>
          <span class="tw-text-right">{{ injury.symptomRecord.dizzy.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Blurred vision</span>
          <span class="tw-text-right">{{ injury.symptomRecord.blurVision.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Balance problems</span>
          <span class="tw-text-right">{{ injury.symptomRecord.balanceProblem.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Light sentivity</span>
          <span class="tw-text-right">{{ injury.symptomRecord.lightSensitivity.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Noise sentivity</span>
          <span class="tw-text-right">{{ injury.symptomRecord.noiseSensitivity.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Slow than normal</span>
          <span class="tw-text-right">{{ injury.symptomRecord.slowedDown.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Fog like feeling</span>
          <span class="tw-text-right">{{ injury.symptomRecord.inAFog.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Not Feeling right</span>
          <span class="tw-text-right">{{ injury.symptomRecord.notFeelRight.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Difficulty concentrating</span>
          <span class="tw-text-right">{{
            injury.symptomRecord.difficultyInConcentrating.stepName
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Difficulty remembering</span>
          <span class="tw-text-right">{{
            injury.symptomRecord.difficultyRemembering.stepName
          }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Fatigued/low energy</span>
          <span class="tw-text-right">{{ injury.symptomRecord.fatigued.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Confused</span>
          <span class="tw-text-right">{{ injury.symptomRecord.confused.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Drowsy</span>
          <span class="tw-text-right">{{ injury.symptomRecord.drowsy.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">More emotional than normal</span>
          <span class="tw-text-right">{{ injury.symptomRecord.emotional.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Irritable</span>
          <span class="tw-text-right">{{ injury.symptomRecord.irritable.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Sadness</span>
          <span class="tw-text-right">{{ injury.symptomRecord.sad.stepName }}</span>
        </div>
        <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
          <span class="tw-text-gray-500">Nervous/anxious</span>
          <span class="tw-text-right">{{ injury.symptomRecord.nervousOrAnxious.stepName }}</span>
        </div>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Player removed by</span>
        <span class="tw-text-right">{{ injury.playerRemoveBy }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Treatment by Ambulance/Doctor</span>
        <span class="tw-text-right">{{ injury.treatPlayer == true ? "Yes" : "No" }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Refered to</span>
        <span class="tw-text-right">{{
          injury.playerReferredTo === "Other"
            ? injury.playerReferredToOther
            : injury.playerReferredTo
        }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">Immediate care</span>
        <span class="tw-text-right">{{
          injury.immediateCare === "Other" ? injury.immediateCareOther : injury.immediateCare
        }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">First Responder Name</span>
        <span class="tw-text-right">{{ injury.firstResponderName }}</span>
      </div>

      <div class="tw-grid tw-grid-cols-2 tw-font-normal tw-text-sm tw-mb-6 tw-leading-14px">
        <span class="tw-text-gray-500">First Responder Role</span>
        <span class="tw-text-right">{{ injury.firstResponderRole }}</span>
      </div>

      <div class="tw-text-left tw-font-normal tw-text-sm tw-text-gray-500">
        Any significant observations
      </div>
      <div class="tw-text-left tw-font-normal tw-text-sm tw-leading-14px tw-pb-8">
        {{ injury.otherSignificants }}
      </div>

      <div
        v-if="viewMore === false && injury.symptons === true"
        class="tw-text-center tw-text-base tw-leading-4"
      >
        <button
          type="link"
          class="tw-text-green-700 hover:tw-text-green-300 tw-underline tw-font-medium"
          @click="viewMore = true"
        >
          View More
        </button>
      </div>

      <div
        v-if="viewMore === true && injury.symptons === true"
        class="tw-text-center tw-text-base tw-leading-4"
      >
        <button
          type="link"
          class="tw-text-green-700 hover:tw-text-green-300 tw-underline tw-font-medium"
          @click="viewMore = false"
        >
          View Less
        </button>
      </div>

      <div
        v-if="injury.symptons === true"
        class="tw-mt-5 tw-text-base tw-font-medium tw-leading-5 tw-text-green-700 tw-text-center"
      >
        <button
          type="link"
          class="tw-text-green-700 hover:tw-text-green-300 tw-font-medium tw-underline"
          @click="hia"
        >
          Click here to access Doctor clearance form - HIA Form
        </button>
      </div>
    </div>

    <div
      class="tw-text-sm tw-mt-4 tw-bg-white tw-shadow-md tw-p-4 tw-font-normal tw-leading-18px tw-text-left"
      v-if="this.$store.getters['user/activeRole'].national_id === 32"
    >
      <span
        >If there were any signs or symptoms of a suspected concussion, please visit
        <a
          href="https://www.playrugbyleague.com/trainer/concussion/"
          target="_blank"
          class="tw-text-green-700 tw-underline tw-font-normal"
          >www.playrugbyleague.com/concussion</a
        >
      </span>
      <p>for further information on the management and return to play processes.</p>
    </div>

    <div class="tw-p-4 tw-bg-white tw-shadow-md tw-mt-8" v-show="emailCard === true">
      <div class="tw-text-base tw-font-medium tw-mb-3">Send report to others</div>
      <div class="tw-font-normal tw-text-sm tw-mb-6">Add as many email addresses as needed.</div>

      <div id="emailForm" class="tw-text-sm tw-text-black">
        <div
          v-for="(email, index) in totalEmails"
          :key="index"
          class="tw-flex tw-flex-wrap tw-flex-row"
        >
          <input
            ref="email"
            class="tw-w-11/12 tw-pb-2 tw-placeholder-gray-400 tw-placeholder-opacity-50 tw-text-sm tw-mb-7 tw-text-gray-800 tw-border-b-2 tw-border-gray-200 tw-bg-transparent tw-shadow-none focus:tw-outline-none tw-h-9"
            auto-complete="off"
            :value="email"
            @change="(email = $event.target.value), (totalEmails[index] = $event.target.value)"
            placeholder="Add Email address"
            required
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6 plus tw-border-b-2 tw-border-gray-200 tw-w-1/12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            v-if="index == totalEmails.length - 1"
            @click="addEmail()"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="tw-mt-8 sm:tw-flex sm:tw-justify-center">
      <div v-show="emailCard === false">
        <button
          type="success"
          size="medium"
          @click="emailCard = true"
          class="tw-justify-center tw-w-full tw-mb-4 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
        >
          Email to Others
        </button>
        <button
          type=""
          size="medium"
          @click="redirectTo"
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-none tw-border-2 tw-border-green-700 hover:tw-border-green-300 hover:tw-text-black sm:tw-w-72"
        >
          Return to Dashboard
        </button>
      </div>
      <div v-show="emailCard === true">
        <button
          type="success"
          class="tw-justify-center tw-w-full tw-mb-4 sm:tw-mr-4 tw-h-10 tw-capitalize tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72"
          size="medium"
          :disabled="isSendMail"
          @click="next"
        >
          Send
        </button>
        <button
          type=""
          class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-capitalize tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-none tw-border-2 tw-border-green-700 hover:tw-border-green-300 hover:tw-text-black sm:tw-w-72"
          size="medium"
          @click="emailCard = false"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import _ from "lodash";
import { errormsg } from "../../utils/constants";

export default {
  props: ["injury"],
  data() {
    return {
      numberOfEmails: 1,
      emailAdd: {
        name: "",
        emailAddress: "",
      },
      newEmail: "",
      emailCard: false,
      email: {
        name: "",
        emailAddress: "",
      },
      totalEmails: [],
      clubEmail: "",
      associationEmail: "",
      programGDOemail: "",
      gamedevregionEmail: "",
      viewMore: false,
      sceneType: [
        { id: 1, name: "Match" },
        { id: 2, name: "Other" },
        { id: 3, name: "Training" },
      ],
      rules: {
        email: [
          {
            type: "email",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              let exists = _.without(this.injury.emails, "").filter((v) => v === value);
              const regex =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (value && !regex.test(String(value).toLowerCase())) {
                return callback(new Error(errormsg.email));
              } else if (exists && exists.length >= 2)
                return callback(new Error(errormsg.email_exist));
              return callback();
            },
          },
        ],
      },
      isSendMail: false,
      moveToNextStep: false,
      userEmail: "",
      programName: "",
      program: {},
    };
  },
  computed: {
    dateOfInjury() {
      return dayjs(this.injury.dateOfInjury).format("DD/MM/YYYY");
    },
    timeOfInjury() {
      return dayjs(this.injury.timeOfInjury).format("h:mm A");
    },
    formatDateOfInjury() {
      if (this.injury.dateOfInjuryStr) {
        const dt = this.injury.dateOfInjuryStr.split("-");
        return `${dt[2]}/${dt[1]}/${dt[0]}`;
      }
      return "";
    },
    formatTimeOfInjury() {
      if (this.injury.timeOfInjuryStr) {
        let time = this.injury.timeOfInjuryStr;
        // Convert time string which is 24hrs format into 12 hrs with AM/ PM
        const time_part_array = time.split(":");
        let ampm = "AM";
        if (time_part_array[0] >= 12) {
          ampm = "PM";
        }
        if (time_part_array[0] > 12) {
          time_part_array[0] = time_part_array[0] - 12;
        }
        const formatted_time = time_part_array[0] + ":" + time_part_array[1] + " " + ampm;
        return formatted_time;
      }
      return "";
    },
    injuryOccur() {
      if (this.injury.scene === 2) return this.injury.sceneOther;
      return this.sceneType.find((type) => type.id === this.injury.scene).name;
    },
  },
  async mounted() {
    const activeRole = this.$store.getters["user/activeRole"];
    // get user email
    this.userEmail = this.$store.getters["user/email"];
    this.injury.emails = [];

    // When a new Injury is added, injury.member.email is null
    if (this.injury.member.email === undefined && this.injury.memberId) {
      try {
        const resp = await this.$http.get(
          `/nrl/api/v1/admin/members/my-members/${this.injury.memberId}/manager`
        );
        const res = resp.data;
        const member = _.merge({}, this.member, res.data);
        this.injury.member.email = member.profile.email;
        this.$store.commit("root/loading", false);
      } catch (e) {
        this.$store.commit("root/loading", false);
        this.$customError(e);
      }
    }

    //Member's email
    const memberEmail = {
      name: this.injury.member.name,
      emailAddress: this.injury.member.email,
    };
    if (memberEmail && memberEmail.emailAddress) {
      this.injury.emails.push(memberEmail); //First element in array will be member's email
    } else {
      this.injury.emails.push(this.emailAdd); //empty email address
    }

    //User's email
    if (this.userEmail) {
      const userFullName = this.$store.getters["user/userName"]
        ? this.$store.getters["user/lastName"]
          ? `${this.$store.getters["user/userName"]} ${this.$store.getters["user/lastName"]}`
          : `${this.$store.getters["user/userName"]}`
        : "";
      const userEmail = {
        name: userFullName,
        emailAddress: this.userEmail,
      };
      this.injury.emails.push(userEmail); //Second element in array will be user's email
    } else {
      this.injury.emails.push(this.emailAdd);
    }

    // Get program Data in case of Program Admin
    if (activeRole.name === "Program Admin" || activeRole.name === "Club Program Admin") {
      try {
        const program = await this.$http.get(
          `/nrl/api/v1/admin/programs/${this.injury.meta.programId}`
        );
        if (program && program.data && program.data.data) {
          this.programName = program.data.data.name;
          this.program = program.data.data;
        }
      } catch (e) {
        this.$store.commit("root/loading", false);
        this.$customError(e);
      }
    }
    // In case of concussion: Send email to Association and Club too
    if (this.injury.symptons) {
      if (activeRole.name === "Program Admin") {
        try {
          const gamedevregion = await this.$http.get(
            `/nrl/api/v1/admin/game-dev-regions/${activeRole.entity._id}`
          );

          if (this.program) {
            this.injury.emails.push({
              emailAddress: this.program.gdo.email,
              name: this.program.gdo.name,
            });
            this.programGDOemail = this.program.gdo.email;
          }
          if (gamedevregion && gamedevregion.data && gamedevregion.data.data) {
            this.injury.emails.push({
              emailAddress: gamedevregion.data.data.contactEmail,
              name: gamedevregion.data.data.contactName,
            });
            this.gamedevregionEmail = gamedevregion.data.data.contactEmail;
          }
        } catch (e) {
          this.$store.commit("root/loading", false);
          this.$customError(e);
        }
      } else {
        let club = {},
          assoc = {};
        if (activeRole.name === "Team Admin") {
          const team = await this.$http.get(`/nrl/api/v1/admin/teams/${activeRole.entity._id}`);

          club = await this.$http.get(
            `/nrl/api/v1/admin/clubsData/${team?.data?.data?.orgtree?.club._id}`
          );
        } else if (activeRole.name === "Club Admin") {
          club = await this.$http.get(`/nrl/api/v1/admin/clubsData/${activeRole.entity._id}`);
        } else if (activeRole.name === "Association Admin") {
          assoc = await this.$http.get(`/nrl/api/v1/admin/associations/${activeRole.entity._id}`);
        }
        const clubEmail = club?.data?.data?.contact?.email;
        if (club) {
          if (clubEmail) {
            this.injury.emails.push({
              emailAddress: clubEmail,
              name: club?.data?.data?.contact?.name,
            });
            this.clubEmail = clubEmail;
          }
          if (
            club.data &&
            club.data.data &&
            club.data.data.orgtree &&
            club.data.data.orgtree.association &&
            club.data.data.orgtree.association._id
          ) {
            const association = await this.$http.get(
              `/nrl/api/v1/admin/associationData/${club.data?.data?.orgtree?.association._id}`
            );
            const associationEmail = association?.data?.data?.contact?.email;

            if (associationEmail) {
              this.injury.emails.push({
                emailAddress: associationEmail,
                name: association?.data?.data?.contact?.name,
              });
              this.associationEmail = associationEmail;
            }
          }
        } else if (assoc) {
          const associationEmail = assoc.contact.email;

          if (associationEmail) {
            this.injury.emails.push({
              emailAddress: associationEmail,
              name: association?.data?.data?.contact?.name,
            });
            this.associationEmail = associationEmail;
          }
        }
      }
    }

    //An empty email
    this.injury.emails.push(this.emailAdd); //Third element in array will be empty

    // encode the member email to show on screen
    this.totalEmails = this.injury.emails.map((email, index) => this.sendToEmail(email, index));
  },
  methods: {
    hia() {
      document.title = `Injury Report - ${this.injury._id} `;
      this.$router.push({ name: "hiaForm", params: { id: this.injury._id } });
    },
    convertBoolToString(fieldName) {
      if (fieldName === undefined) return;
      let newFieldValue = fieldName.toString();
      // By default value when injury already existed with Bool value true
      if (newFieldValue === "true") return (newFieldValue = "Yes -Observed");
      else if (newFieldValue === "false") return (newFieldValue = "No");
      return newFieldValue;
    },
    formatBoolean(val) {
      if (_.isNil(val)) return "";
      return val ? "Yes" : "No";
    },
    goToEditPage() {
      this.$emit("editReport", this.injury);
    },
    sendToEmail(email, index) {
      if (email && email?.name && email?.emailAddress) {
        // Name display like Clint Westwood
        let name = email.name.replace(/\w\S*/g, function (t) {
          return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
        });

        //convert email address in encrypt form
        if (index === 0) {
          let encryptEmail = "";
          let emailAddressArray = email.emailAddress.split("@");
          let size = emailAddressArray[0].length;
          if (size > 0) {
            encryptEmail = `${emailAddressArray[0].charAt(0)}***${emailAddressArray[0].substr(
              size - 2
            )}@${emailAddressArray[1]}`;
            return `${name} - ${encryptEmail}`;
          }
        } else {
          return `${name} - ${email.emailAddress}`;
        }
      }
      const emptyEmail = {
        name: "",
        emailAddress: "",
      };
      return "";
    },
    async next() {
      const activeRole = this.$store.getters["user/activeRole"];
      this.isSendMail = true;

      let { matches, ...data } = this.injury;

      data.emails = [];

      // get the first decoded email from injury emails
      const memberEmail = this.injury?.emails[0];

      this.injury.emails = this.totalEmails.map((email) => this.getEmailAddress(email));

      // check if the member email is changed or not while updating the emails :
      if (this.injury?.emails[0]) {
        const oldEncodedMemberEmail = this.sendToEmail(memberEmail, 0);
        const newEncodedMemberEmail = this.sendToEmail(this.injury.emails[0], 0);

        if (oldEncodedMemberEmail === newEncodedMemberEmail) {
          this.injury.emails[0] = memberEmail; // decoded member email
        }
      }

      let filteredEmails = [];
      this.injury?.emails.forEach((email) => {
        if (email && email.emailAddress) {
          filteredEmails.push(email);
          data.emails.push(email.emailAddress);
        }
      });

      this.injury.emails = filteredEmails;

      //Find unique emails

      data.emails = _.uniqWith(data.emails, _.isEqual);

      if (activeRole.name === "Program Admin" || activeRole.name === "Club Program Admin") {
        data.programName = this.programName;
      }

      // In case of concussion
      if (this.injury.symptons) {
        data.concussion.lossOfConsciousness = this.convertBoolToString(
          data.concussion.lossOfConsciousness
        );
        data.concussion.protectiveAction = this.convertBoolToString(
          data.concussion.protectiveAction
        );
        data.concussion.impact = this.convertBoolToString(data.concussion.impact);
        data.concussion.balanceDisturbance = this.convertBoolToString(
          data.concussion.balanceDisturbance
        );
        data.concussion.dazedOrBlank = this.convertBoolToString(data.concussion.dazedOrBlank);
        data.concussion.unusualBehaviour = this.convertBoolToString(
          data.concussion.unusualBehaviour
        );
        data.concussion.confusion = this.convertBoolToString(data.concussion.confusion);
        data.concussion.memoryImpairment = this.convertBoolToString(
          data.concussion.memoryImpairment
        );
        data.concussion.playerReports = this.convertBoolToString(data.concussion.playerReports);
      }

      if (this.injury.symptons) {
        if (activeRole.name === "Program Admin") {
          const indexGDOEmail = data.emails.indexOf(this.programGDOemail);
          if (indexGDOEmail >= 0) data.emails.splice(indexGDOEmail, 1);

          const indexGamedevRegionEmail = data.emails.indexOf(this.gamedevregionEmail);

          if (indexGamedevRegionEmail >= 0) data.emails.splice(indexGamedevRegionEmail, 1);
        } else {
          // Exclude clubEmail and association Email from the list

          const indexClubEmail = data.emails.indexOf(this.clubEmail);

          if (indexClubEmail >= 0) data.emails.splice(indexClubEmail, 1);

          const indexAssocEmail = data.emails.indexOf(this.associationEmail);

          if (indexAssocEmail >= 0) data.emails.splice(indexAssocEmail, 1);
        }
      }
      data.sendToClubAssoc = false;
      data.sendToProgram = false;
      try {
        if (data.emails.length > 0) {
          const resp = await this.$http.post("/nrl/api/v1/admin/injury-report/email", data);
          const res = resp.data;
        }

        if (this.injury.symptons) {
          if (activeRole.name === "Program Admin") {
            // send email to Program GDO and gamdev region
            data.emails = [];

            if (this.programGDOemail !== "") data.emails.push(this.programGDOemail);
            if (this.gamedevregionEmail !== "") data.emails.push(this.gamedevregionEmail);

            data.sendToProgram = true;
          } else {
            // send email to club and association now
            data.emails = [];
            if (this.clubEmail !== "") data.emails.push(this.clubEmail);
            if (this.associationEmail !== "") data.emails.push(this.associationEmail);

            data.sendToClubAssoc = true;
          }
          if (data.emails.length > 0) {
            const resp1 = await this.$http.post("/nrl/api/v1/admin/injury-report/email", data);
            const res1 = resp1.data;
          }
        }
        this.moveToNextStep = true;

        this.$emit("next", this.injury, this.moveToNextStep, memberEmail);

        this.isSendMail = false;
        this.$store.commit("root/loading", false);
      } catch (e) {
        this.$store.commit("root/loading", false);
        this.$customError();
        this.isSendMail = false;
      }
    },
    redirectTo() {
      this.$emit("redirectTo");
    },
    addEmail() {
      this.totalEmails.push("");
    },

    addNewEmail(email) {
      this.totalEmails.push(email);
    },
    getEmailAddress(email) {
      if (email === "") return;
      const fullEmail = email.split("- ");
      const e = {};
      if (fullEmail[1]) {
        e.name = fullEmail[0].trim();
        e.emailAddress = fullEmail[1].trim();
      } else {
        e.name = "";
        e.emailAddress = email.trim();
      }
      return e;
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  .card {
    margin: 20px auto;
    width: 50%;
    max-width: 100%;
    overflow: hidden;
    text-align: center;

    .right {
      text-align: right;
      word-break: break-word;
    }

    .left {
      text-align: left;
    }

    .heading {
      font-weight: 600;
    }

    .color {
      color: #098255;
      font-weight: 500;
    }
  }
  @media only screen and (max-width: $sm) {
    .card {
      width: 80%;
    }
  }
}

.el-row {
  margin-bottom: 20px;
}

.plus {
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position-y: 10px;
  @apply tw-py-2 tw-mb-7 tw-text-sm tw-text-gray-800 tw-placeholder-gray-800 tw-bg-transparent  tw-shadow-none focus:tw-outline-none tw-h-9;
}
</style>
<style>
.lstemail.el-row {
  position: relative;
}

.lstemail button {
  right: 0;
  position: absolute;
  border: 0px !important;
  background: transparent;
  outline: none;
  width: 10px;
}

.lstemail button:hover,
.lstemail button:focus {
  background: transparent !important;
  border-color: transparent !important;
  width: 10px;
}

.emails-ruleForm .el-form-item__content {
  margin-left: unset !important;
}

.summary-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.summary-info span a {
  color: #0052cc;
}

/* .error {
  @apply tw-border-red-600 tw-border-b-2 tw-placeholder-red-600 tw-text-red-600;
} */
</style>
